import { z } from 'zod';
import { createAppInsertSchema, schemaToModelChange } from '../../utils/schema';
import * as schema from '@strength/db-schema';
import { zWorkoutLayer } from '../../workout/layer';
import { zDate } from '../../core';
export var AthleteActualWorkoutDomain;
(function (AthleteActualWorkoutDomain) {
    AthleteActualWorkoutDomain.Module = 'AthleteActualWorkout';
    AthleteActualWorkoutDomain.zEdit = schemaToModelChange('AthleteActualWorkoutLayer', createAppInsertSchema(schema.AthleteActualWorkoutLayer)
        .omit({
        blockId: true,
        profileId: true,
        workoutId: true,
        athleteVersion: true,
        blockVersion: true,
    })
        .extend({
        // `createInsertSchema` doesn't handle the layer type very well
        layer: zWorkoutLayer,
    }));
    const zIdentity = z.object({
        blockId: z.uuid(),
        profileId: z.uuid(),
        workoutId: z.uuid(),
        athleteVersion: z.number(),
        blockVersion: z.number(),
        // Set only for manual entry on a day with no scheduled workout at all
        // (no BlockPublishedWorkoutLayer, no draft). `workoutId` is then a
        // client-generated synthetic uuid and `athleteVersion` is 0; the date is
        // what lets the server manufacture the missing scaffolding. Omitted for
        // every other save.
        assignedDate: zDate.optional(),
    });
    AthleteActualWorkoutDomain.zCommand = z.object({
        module: z.literal(AthleteActualWorkoutDomain.Module),
        identity: zIdentity,
        edits: AthleteActualWorkoutDomain.zEdit.array(),
        // Can't type this as Workout because of cyclical dependency with @strength/domain-workout
        workout: z.any().optional(),
    });
})(AthleteActualWorkoutDomain || (AthleteActualWorkoutDomain = {}));
//# sourceMappingURL=domain.js.map